(ns ycweb.app.admin.tasks.tasks
  (:require
   [inflections.core :as inflections]
   #?@(:clj
       [[clj-time.core :as dt]
        [clj-time.coerce :as dtc]]
       :cljs
       [[cljs-time.core :as dt]
        [cljs-time.coerce :as dtc]])
   [rum.core :as rum]
   [util.string :as str]
   [clojure.set :as set]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.richeditor :as richeditor]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.app.admin.tasks.common :as yaatc.common]
   [ycweb.app.admin.tasks.forms.incident]
   [ycweb.app.admin.tasks.forms.devtask]
   [ycweb.app.admin.tasks.forms.task]
   [ycweb.app.admin.tasks.views.grid :as task-grid]
   [ycweb.app.admin.tasks.views.kanban :as kanban]))

(def default-view-id "active-this-week")

(defn view-list [app-atom]
  (let [app-user (cmn/curact app-atom :user)
        user-uuid (u/uuid (:uuid app-user))]
    [{:title "All Tasks"
      :id "all-tasks"
      :kanban
      {:config
       {:grouping-key :task/dev-status}}}

     {:title "Active this week"
      :id "active-this-week"
      :filters
      {:task.dev-status
       {:options
        [:task.dev-status/selected
         :task.dev-status/doing
         :task.dev-status/pr
         :task.dev-status/checking]}}
      :kanban
      {:config
       {:grouping-key :task/dev-status}}}

     {:title "Review done tasks"
      :id "review-done-tasks"
      :filters
      {:task.dev-status
       {:options
        [:task.dev-status/done]}}
      :kanban
      {:config
       {:grouping-key :task/dev-status}}}

     {:title "Replenish Tasks"
      :id "replenish-tasks"
      :filters
      {:task.dev-status
       {:options
        [:task.dev-status/next
         :task.dev-status/selected]}
       :task.stream
       {:options
        [:task.stream/bug
         :task.stream/incident]}}
      :kanban
      {:config
       {:grouping-key :task/dev-status}}}

     {:title "Empty budget"
      :id "empty-time"
      :filters
      {:budget
       {:options [0]}}
      :kanban
      {:config
       {:grouping-key :task/dev-status
        :empty-time [0]}}}

     {:title "Assigned to me"
      :id "assigned"
      :filters
      {:assigned-users
       {:options [user-uuid]}}
      :kanban
      {:config
       {:grouping-key :task/dev-status
        :assigned []}}}

     {:title "Requested by me"
      :id "requested"
      :filters
      {:requested-users
       {:options [user-uuid]}}
      :kanban
      {:config
       {:grouping-key :task/dev-status
        :requested []}}}]))

(defn lookup-view [views view-id]
  (let [idx-views (u/index-by :id views)]
    (get idx-views view-id)))

(defmethod grid/action :admin.tasks/change-dashboard-view [app-atom {:keys []}]
  (urlstate/redirect app-atom "tasks" nil {:view default-view-id}))

(defmethod grid/action :admin.tasks/multi-filter-update
  [app-atom {:keys [filter-input item-selector selected-key selected-item]}]
  (let [process-atom (cmn/process-cursor app-atom)
        lookup-atom (rum/cursor process-atom :lookup)]
    (swap! lookup-atom update filter-input
      (fn [current-options]
        (assoc-in current-options
          [(get selected-item item-selector) (or selected-key :selected?)]
          (not (get selected-item (or selected-key :selected?))))))))

(defmethod grid/action :admin.tasks/multi-select-update
  [app-atom {:keys [entity-atom filter-selector item-selector selected-key selected-item]}]
  (swap! entity-atom update filter-selector
    (fn [current-options]
      (let [existing-option (get current-options (get selected-item item-selector))
            selected?
            (not
              (if existing-option
                (get existing-option (or selected-key :selected?))
                (get selected-item (or selected-key :selected?))))]

        (assoc-in current-options
          [(get selected-item item-selector)]
          (assoc selected-item (or selected-key :selected?) selected?))))))

(defn transform-filters [lookup filters]
  (reduce
    (fn [acc [k v]]
      (let [{:keys [options] :as cfg} (get filters k)]
        (assoc acc k
          (reduce
            (fn [mini-acc [option-key option-values]]
              (assoc mini-acc option-key (assoc option-values :selected? (contains? (set options) option-key))))
            {} v))))
    {} lookup))

(defn select-filter-by-view [app-atom filters]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom update :lookup
      (fn [lookup]
        (transform-filters lookup filters)))))

(defmethod grid/action :admin.tasks/select-filters-by-view
  [app-atom {:keys [filters]}]
  (select-filter-by-view app-atom filters))

(rum/defc task-list [app-atom]
  (datatables/table app-atom :admin.tasks/list task-grid/tasks-table-fns))

(rum/defc dashboard-header  < rum/reactive cmn/cursors [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        lookup-atom (rum/cursor process-atom :lookup)
        current-view (lookup-view (view-list app-atom) (cmn/curact action-atom [:view]))
        project-atom (rum/cursor lookup-atom :task.project)
        project-options (rum/react project-atom)

        selected-projects
        (->>
          project-options
          (vals)
          (filter #(:selected? %)))

        {:task-project/keys [timing phase date-target date-deadline deadline-risk tech-lead developer]}
        (first selected-projects)

        single-project? (= (count selected-projects) 1)
        project-view? (>= (count selected-projects) 1)
        filtered-tasks (yaatc.common/filter-tasks app-atom (vals (cmn/curact process-atom :tasks)))
        budget-hours (reduce (fnil + 0 0) 0 (map :task/budget filtered-tasks))
        spent-hours (reduce (fnil + 0 0) 0 (map :task/time-spent filtered-tasks))

        completed-tasks
        (filter
          #(contains? #{:task.dev-status/done :task.dev-status/archived} (:db/ident (:task/dev-status %)))
          filtered-tasks)

        completed-tasks-budget (reduce (fnil + 0 0) 0 (map :task/budget completed-tasks))

        percentage-done
        (if (> completed-tasks-budget 0)
          (Math/floor (* 100 (/ completed-tasks-budget budget-hours)))
          0)

        page-heading
        (cond
          project-view?
          (str
            (if single-project? "Project" (inflections/pluralize (count selected-projects) "Project"))
            ": " (str/join ", " (map :ent/display-name selected-projects)))

          :else
          (:title current-view))]

    [:div
     (headings/heading page-heading
       {:type :h2
        :size :default
        :flush true
        :subtext
        (when single-project?
          [:div
           "Timing: "
           (when timing
             [:span
              {:class (u/bem :text-pill [:medium :light])
               :style {:background-color (or (:ent/color timing) "#eeeeee")}}
              (:ent/display-name timing)])
           " | Phase: "
           (when phase
             [:span
              {:class (u/bem :text-pill [:medium :light])
               :style {:background-color (or (:ent/color phase) "#eeeeee")}}
              (:ent/display-name phase)])])})

     [:div {:class (u/bem :flex-grid-group [:align-left :flush-force])}
      [:div {:class (u/bem :flex-grid-block [:fluid :t-1-2])}
       [:div.flex-grid-content
        [:ul {:class (u/bem :list [:no-bullets])}
         (when project-view?
           [:li [:b "View: "] (:title current-view)])
         [:li [:b "Budgeted: "] (inflections/pluralize budget-hours "hour")]
         [:li [:b "Time spent: "] (inflections/pluralize spent-hours "hour")]
         [:li [:b "Tasks: "] (count filtered-tasks)]
         [:li [:b "Percentage done: "] percentage-done "% "
          [:span.yc-paragraph--small-force "(this assumes all tasks have budgets)"]]]]]

      (when single-project?
        [:div {:class (u/bem :flex-grid-block [:fluid :t-1-2])}
         [:div.flex-grid-content
          [:ul {:class (u/bem :list [:no-bullets])}
           [:li [:b "Target date: "]
            (if date-target
              (ud/format-date date-target "d MMMM YYYY")
              "None")]

           [:li [:b "Deadline date: "]
            (if date-deadline
              (ud/format-date date-deadline "d MMMM YYYY")
              "None")]

           [:li [:b "Deadline risk: "]
            (if deadline-risk
              deadline-risk
              "N/A")]

           [:li [:b "Tech lead: "]
            (if tech-lead
              (:ent/display-name tech-lead)
              "None")]

           [:li [:b "Interested Devs: "]
            (if developer
              (str/join ", " (map #(:ent/display-name %) developer))
              "None")]]]])]

     [:div
      {:class (u/bem :flex-grid-group [:flush-force :align-left :valign-middle])}
      #_[:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (buttons/button-web "New task"
            {:type :button
             :style :primary
             :size :default
             :icon :plus
             :on-click
             #(grid/dispatch-action app-atom :admin.tasks/new-task {})})]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Refresh"
          {:type :button
           :on-click #(grid/dispatch-action app-atom :admin.tasks/refresh {})
           :style :secondary
           :size :default})]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Load all tasks"
          {:type :button
           :on-click #(grid/dispatch-action app-atom :admin.tasks/all-tasks {})
           :style :secondary
           :size :default})]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid :align-right])}
       [:div.flex-grid-content
        (forms/toggle "Card view"
          (rum/cursor-in app-atom [:view :kanban]) {})]]]]))

(rum/defcs task-filters < rum/reactive cmn/cursors
  (rum/local {:open? false} ::state)
  [s app-atom]
  (let [local-atom (::state s)
        filter-opened? (cmn/curact local-atom :open?)
        process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        lookup-atom (rum/cursor process-atom :lookup)
        filter-atom (rum/cursor process-atom :filters)
        selected-view-id (cmn/curact filter-atom :view)

        project-atom (rum/cursor lookup-atom :task.project)
        project-options (rum/react project-atom)

        dev-status-atom (rum/cursor lookup-atom :task.dev-status)
        dev-status-options (rum/react dev-status-atom)

        stream-atom (rum/cursor lookup-atom :task.stream)
        stream-options (rum/react stream-atom)

        type-atom (rum/cursor lookup-atom :task.type)
        type-options (rum/react type-atom)

        assigned-atom (rum/cursor lookup-atom :assigned-users)
        assigned-options
        (->>
          (rum/react assigned-atom)
          (vals))

        requested-atom (rum/cursor lookup-atom :requested-users)
        requested-options
        (->>
          (rum/react requested-atom)
          (vals))

        display-name-filter-pred
        #(str/includes? (str/lower-case (:ent/display-name %1)) (str/lower-case %2))]

    [:div
     [:div.u-max-width-240
      (buttons/button-web
        (if filter-opened?
          "Hide filter options"
          "Show filter options")
        {:type :button
         :on-click #(swap! local-atom assoc :open? (not filter-opened?))
         :style :secondary
         :full true})]

     (when filter-opened?
       (list
         [:div.u-margin-top-20
          {:class (u/bem :flex-grid-group [:flush-force :valign-middle :align-left])}
          [:div
           {:class (u/bem :flex-grid-block [:m-3-3])}
           [:div.flex-grid-content
            (forms/select "View:"
              (rum/cursor action-atom :view)
              (map
                (fn [{:keys [id title]}]
                  {:value id :text title})
                (view-list app-atom))
              {:default selected-view-id
               :change-fn
               (fn [_ v]
                 (let [view-lookup (lookup-view (view-list app-atom) v)]
                   (urlstate/redirect app-atom "tasks" nil
                     (merge
                       (cmn/screen-params app-atom)
                       {:view (:id view-lookup)}))))})]]

          [:div
           {:class (u/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (forms/form-field
              "Dev Status" {}
              (forms/inline-autocomplete-select
                (into
                  [:div {:style {:padding-top "10px" :overflow "hidden" :white-space "nowrap"}}]
                  (->>
                    dev-status-options
                    (vals)
                    (filter #(:selected? %))
                    (map
                      #(yaatc.common/status-selected app-atom
                         {:filter-input :task.dev-status :selected-item %} {} %))))
                (->>
                  dev-status-options
                  (vals)
                  (sort-by :ent/sort-order))
                {:select-style? true
                 :force-open? true
                 :select-fn
                 #(grid/dispatch-action app-atom :admin.tasks/multi-filter-update
                    {:filter-input :task.dev-status :item-selector :db/ident :selected-item %})
                 :item-render-fn (partial yaatc.common/status-toggle app-atom dev-status-atom {:item-selector :db/ident})
                 :filter-fn display-name-filter-pred}))]]

          [:div
           {:class (u/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (forms/form-field
              "Streams" {}
              (forms/inline-autocomplete-select
                (into
                  [:div {:style {:padding-top "10px" :overflow "hidden" :white-space "nowrap"}}]
                  (->>
                    stream-options
                    (vals)
                    (filter #(:selected? %))
                    (map
                      #(yaatc.common/status-selected app-atom
                         {:filter-input :task.stream :selected-item %} {} %))))
                (->>
                  stream-options
                  (vals)
                  (sort-by :ent/sort-order))
                {:select-style? true
                 :force-open? true
                 :select-fn
                 #(grid/dispatch-action app-atom :admin.tasks/multi-filter-update
                    {:filter-input :task.stream :item-selector :db/ident :selected-item %})
                 :item-render-fn (partial yaatc.common/status-toggle app-atom stream-atom {:item-selector :db/ident})
                 :filter-fn display-name-filter-pred}))]]

          [:div
           {:class (u/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (forms/form-field
              "Types" {}
              (forms/inline-autocomplete-select
                (into
                  [:div {:style {:padding-top "10px" :overflow "hidden" :white-space "nowrap"}}]
                  (->>
                    type-options
                    (vals)
                    (filter #(:selected? %))
                    (map
                      #(yaatc.common/status-selected app-atom
                         {:filter-input :task.type :selected-item %} {} %))))
                (->>
                  type-options
                  (vals)
                  (sort-by :ent/sort-order))
                {:select-style? true
                 :force-open? true
                 :select-fn
                 #(grid/dispatch-action app-atom :admin.tasks/multi-filter-update
                    {:filter-input :task.type :item-selector :db/ident :selected-item %})
                 :item-render-fn (partial yaatc.common/status-toggle app-atom type-atom {:item-selector :db/ident})
                 :filter-fn display-name-filter-pred}))]]

          [:div
           {:class (u/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (forms/form-field
              "Projects" {}
              (forms/inline-autocomplete-select
                (into
                  [:div {:style {:padding-top "10px" :overflow "hidden" :white-space "nowrap"}}]
                  (->>
                    project-options
                    (vals)
                    (filter #(:selected? %))
                    (map
                      #(yaatc.common/status-selected app-atom
                         {:filter-input :task.project :selected-item %} {} %))))
                (->>
                  project-options
                  (vals)
                  (sort-by (comp :ent/sort-order :task-project/timing)))
                {:select-style? true
                 :force-open? true
                 :select-fn
                 #(grid/dispatch-action app-atom :admin.tasks/multi-filter-update
                    {:filter-input :task.project :item-selector :ent/uuid :selected-item %})
                 :item-render-fn
                 (partial yaatc.common/status-toggle app-atom project-atom
                   {:item-selector :ent/uuid})
                 :filter-fn display-name-filter-pred}))]]

          [:div
           {:class (u/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (forms/form-field
              "Assigned" {}
              (forms/inline-autocomplete-select
                (into
                  [:div {:style {:padding-top "8px" :overflow "hidden" :white-space "nowrap"}}]
                  (->>
                    assigned-options
                    (filter #(:selected? %))
                    (map
                      #(yaatc.common/person-cell-selected app-atom
                         {:filter-input :assigned-users :selected-item %} {} %))))
                (sort-by :ent/display-name assigned-options)
                {:select-style? true
                 :force-open? true
                 :initial-list
                 (filter
                   #(= "Technology" (:staff/department %))
                   assigned-options)
                 :select-fn
                 #(grid/dispatch-action app-atom :admin.tasks/multi-filter-update
                    {:filter-input :assigned-users
                     :item-selector :ent/uuid
                     :selected-key :selected?
                     :selected-item %})
                 :item-render-fn
                 (partial yaatc.common/person-cell-toggle app-atom assigned-atom
                   {:item-selector :ent/uuid
                    :selected-key :selected?})
                 :filter-fn display-name-filter-pred}))]]

          [:div
           {:class (u/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (forms/form-field
              "Requestor" {}
              (forms/inline-autocomplete-select
                (into
                  [:div {:style {:padding-top "8px" :overflow "hidden" :white-space "nowrap"}}]
                  (->>
                    requested-options
                    (filter #(:selected? %))
                    (map
                      #(yaatc.common/person-cell-selected app-atom
                         {:filter-input :requested-users :selected-item %} {} %))))
                (sort-by :ent/display-name requested-options)
                {:select-style? true
                 :force-open? true
                 :select-fn
                 #(grid/dispatch-action app-atom :admin.tasks/multi-filter-update
                    {:filter-input :requested-users
                     :item-selector :ent/uuid
                     :selected-key :selected?
                     :selected-item %})
                 :item-render-fn
                 (partial yaatc.common/person-cell-toggle app-atom requested-atom
                   {:item-selector :ent/uuid
                    :selected-key :selected?})
                 :filter-fn display-name-filter-pred}))]]]))]))

(rum/defc task-dashboard < rum/reactive cmn/cursors [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        kanban (cmn/curact app-atom [:view :kanban])
        batch-atom (rum/cursor process-atom :batch-cfg)
        batch-cfg (rum/react batch-atom)
        batch-number (cmn/curact batch-atom :batch-number)
        total-batches (cmn/curact batch-atom :total-batches)]

    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush-force :align-left :valign-middle])}
      (headings/heading "Tasks Dashboard" {:type :h1 :size :large})]
     (task-filters app-atom)

     [:div
      [:hr.yc-hr.yc-hr--small]
      (cond
        (:loading? batch-cfg)
        [:p.u-text-center
         (str "Loading " batch-number " out of " total-batches)])]

     [:div.u-relative
      (dashboard-header app-atom)

      [:div.u-relative
       (cond
         kanban
         (kanban/kanban-dashboard app-atom (cmn/curact process-atom :tasks))

         :else
         (task-list app-atom))]
      (toaster/loading-overlay app-atom :admin.tasks/task-view)]]))

(defmethod t/transition-open :admin.tasks [app-atom _ params]
  (let [process-atom (cmn/process-cursor app-atom)
        views (cmn/curact process-atom :view-list)
        batch-cfg (cmn/curact process-atom :batch-cfg)
        filter-atom (rum/cursor process-atom :filters)
        lookup (cmn/curact process-atom :lookup)
        selected-view-id (cmn/curact filter-atom :view)
        param-view-id (or (:view params) default-view-id)
        selected-task (cmn/curact process-atom [:selected-task :task])]

    (when-not views
      (swap! process-atom assoc :view-list (u/index-by :id (view-list app-atom))))

    (when-not (= selected-view-id param-view-id)
      (let [view-lookup (lookup-view (view-list app-atom) param-view-id)]
        (swap! filter-atom assoc :view (:id view-lookup))
        (when lookup
          (select-filter-by-view app-atom (:filters view-lookup)))))

    (when (nil? batch-cfg)
      (toaster/open-overlay app-atom :admin.tasks/task-view)
      (comms/send :admin.tasks/lookup {}))

    (cond
      (:task-uuid params)
      (let [task (get-in @process-atom [:tasks (u/uuid (:task-uuid params))])]
        (cond
          (nil? task)
          (do
            (swap! process-atom assoc :selected-task {:layout :modal})
            (comms/send :admin.tasks/view {:task-uuid (:task-uuid params)}))

          :else
          (do
            (when-not (= (u/uuid (:task-uuid params)) (:ent/uuid selected-task))
              (swap! process-atom assoc :selected-task {:task task :layout :modal}))
            (grid/open-modal app-atom :admin.tasks/task-view {}))))

      :else
      (grid/close-modal app-atom))))

(defmethod comms/receive :admin.tasks/view [app-atom {:keys [task] :as e}]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-task (cmn/curact process-atom :selected-task)]
    (swap! (cmn/process-cursor app-atom) assoc-in [:tasks (:ent/uuid task)] task)
    (cond
      (= (:layout selected-task) :page)
      (swap! process-atom assoc :selected-task {:task task :layout :page})

      (= (:layout selected-task) :modal)
      (do
        (swap! process-atom assoc :selected-task {:task task :layout :modal})
        (grid/open-modal app-atom :admin.tasks/task-view {}))

      :else
      (do
        (toaster/open-toast app-atom :error "Task does not exist." {})
        (urlstate/redirect app-atom "tasks" nil
          (dissoc (cmn/screen-params app-atom) :task-uuid))))))

(defmethod comms/receive :admin.tasks/lookup [app-atom e]
  (let [process-atom (cmn/process-cursor app-atom)
        lookup (cmn/curact process-atom :lookup)
        filter-atom (rum/cursor process-atom :filters)
        selected-view-id (cmn/curact filter-atom :view)
        view-id (or selected-view-id default-view-id)
        view-lookup (lookup-view (view-list app-atom) view-id)]
    (toaster/close-overlay app-atom :admin.tasks/task-view)
    (when-not lookup
      (let [users (get-in e [:lookup :user])
            times (get-in e [:lookup :times])
            lookup
            (->
              (:lookup e)
              (assoc :assigned-users users)
              (assoc :requested-users users)
              (assoc :budget times)
              (assoc :time-spent times))]
        (swap! (cmn/process-cursor app-atom) assoc
          :batch-cfg
          {:batch-number (:batch-number e)
           :total-batches (:total-batches e)}
          :lookup (transform-filters lookup (:filters view-lookup)))))))

(defmethod comms/receive :admin.tasks/list [app-atom e]
  (swap! (cmn/process-cursor app-atom) merge e)
  (datatables/initiate app-atom task-grid/tasks-table-config {}))

(defmethod comms/receive :admin.tasks/update-list [app-atom e]
  (when (= (:batch-number e) 1)
    (toaster/close-toast app-atom))
  (swap! app-atom update :admin.tasks
    (fn [process]
      (let [total-batches
            (or (:total-batches e) (get-in process [:batch-cfg :total-batches]))]

        (->
          process
          (assoc
            :tasks (merge (:tasks process) (:tasks e)))
          (update :batch-cfg assoc
            :batch-number (:batch-number e)
            :loading? (< (:batch-number e) total-batches)))))))

(defmethod grid/action :admin.tasks/refresh [app-atom _]
  (let [process-atom (cmn/process-cursor app-atom)
        batch-atom (rum/cursor process-atom :batch-cfg)
        total-batches (cmn/curact batch-atom :total-batches)]
    (when-not (:loading? @batch-atom)
      (toaster/open-toast app-atom :processing "Loading" {})
      (swap! batch-atom assoc
        :batch-number 0
        :loading? true)
      (comms/send :admin.tasks/update-list
        {:starting-batch-num 0
         :num-of-batches total-batches}))))

(defmethod grid/action :admin.tasks/all-tasks [app-atom _]
  (let [process-atom (cmn/process-cursor app-atom)
        batch-atom (rum/cursor process-atom :batch-cfg)]

    (when-not (:loading? @batch-atom)
      (toaster/open-toast app-atom :processing "Loading" {})
      (swap! batch-atom assoc
        :batch-number 0
        :loading? true)
      (comms/send :admin.tasks/all-tasks {}))))

(defmethod grid/action :admin.tasks/save-task-view [app-atom config _]
  #_(comms/send :admin.tasks/save
      {:task (yaatc.common/reshape-task-save (:task config))})

  (grid/dispatch-modal-action app-atom :admin.tasks/old-close-task-view {}))

(defmethod t/transition-after-open :admin.tasks [app-atom _ _]
  (dcommon/kill-search-bar)
  (presence/open app-atom {:context/ident :admin.tasks})
  (datatables/initiate app-atom task-grid/tasks-table-config {})
  (let [process-atom (cmn/process-cursor app-atom)
        params (cmn/screen-params app-atom)

        batch-cfg (cmn/curact process-atom :batch-cfg)
        task (get-in @process-atom [:tasks (u/uuid (:task-uuid params))])]
    (when
      (and
        (not (:loading? batch-cfg))
        (< (:batch-number batch-cfg) (:total-batches batch-cfg)))
      (swap! process-atom assoc-in [:batch-cfg :loading?] true)
      (comms/send :admin.tasks/update-list
        {:starting-batch-num (:batch-number batch-cfg)
         :num-of-batches (- (:total-batches batch-cfg) (:batch-number batch-cfg))}))

    (when task
      (presence/open-inline-node app-atom {:ent/uuid (:ent/uuid task) :context/type :task}))))


(defmethod flow/render-screen :admin.tasks [app-atom _]
  (task-dashboard app-atom))

(defmethod comms/receive :admin.tasks/broadcast-tasks [app-atom e]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-task-atom (rum/cursor process-atom :selected-task)
        task (cmn/curact selected-task-atom :task)
        layout (cmn/curact selected-task-atom :layout)
        idx-tasks (u/index-by :ent/uuid (:tasks e))
        num-of-tasks (count (:tasks e))]
    (toaster/open-toast app-atom :success
      (str num-of-tasks " task"
        (if (> num-of-tasks 1) "s have" " has")
        " been updated")
      {:closetime 2000})
    (cond
      (and
        task
        (= :modal layout)
        (grid/modal-open? app-atom))
      (let [matched-task (get idx-tasks (:ent/uuid task))]
        (swap! app-atom update :admin.tasks
          (fn [process]
            (let [updated-broadcast-tasks
                  (cond
                    (and
                      matched-task
                      (dt/before?
                        (dtc/to-date-time (:airtable/date-modified task))
                        (dtc/to-date-time (:airtable/date-modified matched-task))))
                    (merge (:broadcast-tasks process) {(:ent/uuid task) matched-task})

                    :else
                    (:broadcast-tasks process))]
              (assoc process
                :tasks (merge (:tasks process) idx-tasks)
                :broadcast-tasks updated-broadcast-tasks)))))

      :else
      (swap! app-atom update :admin.tasks
        (fn [process]
          (assoc process
            :tasks (merge (:tasks process) idx-tasks)))))))


(defmethod comms/receive :admin.tasks/broadcast-task [app-atom e]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-task-atom (rum/cursor process-atom :selected-task)
        task (cmn/curact selected-task-atom :task) layout (cmn/curact selected-task-atom :layout)]
    (when
      (and
        task
        (= :page layout))
      (toaster/open-toast app-atom :success
        (str (get-in e [:task :ent/display-name]) " has been updated")
        {:closetime 2000})
      (swap! app-atom update :admin.tasks
        (fn [process]
          (let [broadcasted-task (:task e)
                idx-task {(:ent/uuid broadcasted-task) broadcasted-task}
                current-selected-task (get-in process [:selected-task :task])
                updated-broadcast-tasks
                (cond
                  (dt/before?
                    (dtc/to-date-time (:airtable/date-modified current-selected-task))
                    (dtc/to-date-time (:airtable/date-modified broadcasted-task)))
                  (merge (:broadcast-tasks process) {(:ent/uuid broadcasted-task) broadcasted-task})

                  :else
                  (:broadcast-tasks process))]

            (assoc process
              :tasks (merge (:tasks process) idx-task)
              :broadcast-tasks updated-broadcast-tasks)))))))